import FullPageLoader from 'components/common/FullPageLoader';
import { buildInvoiceGroups, getInvoiceGroupByConfig } from 'helpers/invoiceGrouping';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';

const PdfForm = ({ data, invoiceNumber, loader, type }) => {
    const { checkPermission } = usePermissions();
    const clientData = data?.client || data;

    const totalBill = clientData?.appointments
        ?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0)
        .toFixed(2);

    const show = (value) => value !== null && value !== undefined && value !== '' && value !== 'N/A';
    const watermarkText = data?.status?.toLowerCase() === 'paid' ? 'MayaBridge' : 'MayaBridge';

    const renderLine = (label, value) => {
        if (!show(value)) return null;
        return (
            <>
                <span>{label}: {value}</span><br />
            </>
        );
    };

    // Calculate Exceeded Time
    const getExceededTime = (scheduledDate, scheduledEnd, actualDate, actualEnd) => {
        if (!scheduledDate || !scheduledEnd || !actualDate || !actualEnd) return null;

        const scheduledEndMoment = moment(`${scheduledDate} ${scheduledEnd}`, "YYYY-MM-DD HH:mm:ss");
        const actualEndMoment = moment(`${actualDate} ${actualEnd}`, "YYYY-MM-DD HH:mm:ss");

        if (!scheduledEndMoment.isValid() || !actualEndMoment.isValid()) return null;

        const exceededSeconds = actualEndMoment.diff(scheduledEndMoment, "seconds");
        if (exceededSeconds <= 0) return null;

        return moment.utc(exceededSeconds * 1000).format("HH:mm:ss");
    };

    const getFullDuration = (actualStartDate, actualStartTime, actualEndDate, actualEndTime) => {
        if (!actualStartDate || !actualStartTime || !actualEndDate || !actualEndTime) return null;

        const startMoment = moment(`${actualStartDate} ${actualStartTime}`, "YYYY-MM-DD HH:mm:ss");
        const endMoment = moment(`${actualEndDate} ${actualEndTime}`, "YYYY-MM-DD HH:mm:ss");

        if (!startMoment.isValid() || !endMoment.isValid()) return null;

        const durationMinutes = endMoment.diff(startMoment, "minutes");
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        if (hours > 0 && minutes > 0) return `${hours} hour ${minutes} minute`;
        if (hours > 0) return `${hours} hour`;
        if (minutes > 0) return `${minutes} minute`;
        return "0 minute";

    };

    // const renderActualStartTime = (appointmentDate, checkinDate, checkinTime) => {
    //     if (!checkinTime || !checkinDate) return null;

    //     const isSameDate = appointmentDate &&
    //         moment(checkinDate).format("YYYY-MM-DD") === moment(appointmentDate).format("YYYY-MM-DD");

    //     if (isSameDate) {
    //         return renderLine(
    //             'Actual Start Time',
    //             moment(checkinTime, "HH:mm:ss").format("h:mm A")
    //         );
    //     }

    //     return renderLine(
    //         'Actual Start Date Time',
    //         `${moment(checkinDate).format("DD/MM/YYYY")} ${moment(checkinTime, "HH:mm:ss").format("h:mm A")}`
    //     );
    // };

    const renderActualStartTime = (checkinDate, checkinTime, checkoutDate, checkoutTime) => {
        if (!checkinTime || !checkinDate) return null;

        const crossesMidnight = checkoutDate &&
            moment(checkoutDate).format("YYYY-MM-DD") !== moment(checkinDate).format("YYYY-MM-DD");

        if (crossesMidnight) {
            return renderLine(
                'Actual Start Date Time',
                `${moment(checkinDate).format("DD/MM/YYYY")} ${moment(checkinTime, "HH:mm:ss").format("h:mm A")}`
            );
        }

        return renderLine(
            'Actual Start Time',
            moment(checkinTime, "HH:mm:ss").format("h:mm A")
        );
    };

    console.log(clientData,'clientDatassss');
    // const groupByConfig = getInvoiceGroupByConfig(clientData?.appointments || [], clientData?.invoice_group_by || data?.invoice_group_by || '');
    const groupByConfig = getInvoiceGroupByConfig(clientData?.invoice_group_by || '');
    const groupedAppointments = buildInvoiceGroups(clientData?.appointments || [], groupByConfig.join(','));

    const renderScheduledStartTime = (date, startTime, endTime) => {
        if (!date || !startTime) return null;

        const crossesMidnight = endTime &&
            moment(endTime, "HH:mm:ss").isBefore(moment(startTime, "HH:mm:ss"));

        if (crossesMidnight) {
            return renderLine(
                'Scheduled Start Date Time',
                `${moment(date).format("DD/MM/YYYY")} ${moment(startTime, "HH:mm:ss").format("h:mm A")}`
            );
        }

        return renderLine(
            'Scheduled Start Time',
            moment(startTime, "HH:mm:ss").format("h:mm A")
        );
    };

    return (
        <>
            <div className="page" style={{ position: 'relative', overflow: 'hidden' }}>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%) rotate(-25deg)',
                        fontSize: '90px',
                        fontWeight: 700,
                        color: 'rgba(0, 0, 0, 0.10)',
                        letterSpacing: '8px',
                        textTransform: 'uppercase',
                        userSelect: 'none',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        pointerEvents: 'none',
                        zIndex: 2,
                        opacity: 0.15,
                    }}
                >
                    {/* {watermarkText} */}
                    <img src="/main-logo.png" alt="Logo" />
                </div>

                <header style={{ position: 'relative', zIndex: 1 }}>
                    <div className="us">
                        <img src="/main-logo.png" alt="Logo" />
                    </div>

                    <div className='d-flex align-items-center'>
                        {show(data?.invoice_number || invoiceNumber) && (
                            <div className="title">
                                <h4>INVOICE # {data?.invoice_number || invoiceNumber}</h4>
                            </div>
                        )}
                        <div className="title">
                            <h4>
                                Date: {data?.billing_date
                                    ? new Date(data.billing_date).toLocaleDateString('en-GB')
                                    : new Date().toLocaleDateString('en-GB')}
                            </h4>
                        </div>
                    </div>
                </header>

                <section style={{ position: 'relative', zIndex: 1 }}>
                    <div className="billed-to">
                        <h1>Bill To</h1>
                        {show(clientData?.user?.name) && <h2>{clientData.user.name}</h2>}
                        {show(clientData?.billing_person) && <h3>{clientData.billing_person}</h3>}
                        {show(clientData?.billing_email) && <h3>{clientData.billing_email}</h3>}
                        {show(clientData?.billing_zipcode || clientData?.city?.name) && (
                            <h3>{clientData?.billing_zipcode} {clientData?.city?.name}</h3>
                        )}
                        {show(clientData?.state?.name) && <h3>{clientData.state.name}</h3>}
                    </div>

                    <div className="invoice-table-wrapper">
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                        {groupedAppointments.map((group, groupIndex) => (
                            <React.Fragment key={`${group.key}-${groupIndex}`}>
                                {groupByConfig.length > 0 && (
                                    <tr>
                                        <td colSpan="3">
                                            <strong>{group.label}</strong>
                                        </td>
                                    </tr>
                                )}
                                {group.appointments.map((val, index) => {
                                    const totalHours = val?.invoice?.total_hours;
                                    const totalMinutes = totalHours
                                        ? (parseInt(totalHours.split(":")[0]) * 60) + parseInt(totalHours.split(":")[1])
                                        : 0;

                                    const minDuration = val?.invoice?.min_duration;
                                    const minDurUnit = val?.invoice?.duration_unit;
                                    const minDurationMinutes = minDurUnit === 'hour' ? minDuration * 60 : minDuration;
                                    const isValid = totalMinutes >= minDurationMinutes;

                                    const inc = val?.invoice?.incremental;
                                    const incremental =
                                        inc === '30_minute' ? '30 minute' :
                                        inc === '1_hour' ? 'hourly' :
                                        inc === 'minute' ? 'per minute' : null;
                                        
                                    const exceededTime = getExceededTime(
                                        val.date, val.end_time,
                                        val.appointment_assign?.checkin_date, val.appointment_assign?.checkout_time
                                    );

                                    const fullDuration = getFullDuration(
                                        val.appointment_assign?.checkin_date,
                                        val.appointment_assign?.checkin_time,
                                        val.appointment_assign?.checkout_date,
                                        val.appointment_assign?.checkout_time
                                    );
                                    
                                    // const hasCustomPricing = !!val?.appointment_custom_pricing;
                                    const customPricing = val?.appointment_custom_pricing;

                                    const hasCustomPricing =
                                        Number(customPricing?.mileage_total || 0) > 0 ||
                                        Number(customPricing?.travel_total || 0) > 0 ||
                                        Number(customPricing?.discount || 0) > 0 ||
                                        Number(val?.invoice?.rush_fee || 0) > 0;

                                    const dynamicFieldsList = (() => {
                                        try {
                                            const parsed = val?.appointment_details?.dynamic_fields
                                                ? JSON.parse(val.appointment_details.dynamic_fields)
                                                : [];
                                            return Array.isArray(parsed) ? parsed.filter(f => f?.show_in_invoice === true) : [];
                                        } catch {
                                            return [];
                                        }
                                    })();

                                    return (
                                        <tr key={`${group.key}-${index}`}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {show(val?.appid) && (
                                                    <>
                                                        <span>
                                                            Appointment Number:&nbsp;
                                                            {checkPermission('Detail Appointments')
                                                                ? <Link to={`/appointments/view/${val.id}`}>{val.appid}</Link>
                                                                : val.appid}
                                                        </span>
                                                        <br />
                                                    </>
                                                )}

                                                {type !== 'compressed' && (
                                                    <>
                                                        {renderLine('Language', val?.language?.name)}

                                                        {/* New Invoice /////////////////////*/}
                                                        {val?.status !== 'completed' && renderLine('Status', val?.status)}
                                                        {/* {renderLine(
                                                            'Date',
                                                            val?.date && `${moment(val.date).format("DD/MM/YYYY")} (${val?.appointment_details?.timezone?.abbreviation} / GMT${val?.appointment_details?.timezone?.utc_offset})`
                                                        )} */}
                                                        {renderLine(
                                                            'Date',
                                                            val?.date && (() => {
                                                                const timezone = val?.appointment_details?.timezone?.name;

                                                                if (!timezone) {
                                                                    return moment(val.date).format("DD/MM/YYYY");
                                                                }

                                                                const dateTime = moment.tz(
                                                                    `${val.date} ${val.start_time || '00:00:00'}`,
                                                                    "YYYY-MM-DD HH:mm:ss",
                                                                    timezone
                                                                );

                                                                return `${dateTime.format("DD/MM/YYYY")} (${dateTime.format("z")} / GMT${dateTime.format("Z")})`;
                                                            })()
                                                        )}

                                                        {show(val?.type) && (
                                                            <>
                                                                <span>
                                                                    Modality:&nbsp;
                                                                    {val?.type}
                                                                </span>
                                                                {minDuration && (
                                                                <span className="font-bold text-red-600">
                                                                    {' ('}
                                                                    {minDuration && `min duration: ${minDuration} ${minDurUnit}`}
                                                                    {')'}
                                                                </span>
                                                                )}
                                                                <br />
                                                            </>
                                                        )}

                                                        {show(val?.type) && (
                                                            <>
                                                                <span>
                                                                    Type:&nbsp;
                                                                    <span className="invoice-subject">
                                                                    {val?.subject}
                                                                    </span>
                                                                </span>

                                                                {(incremental) && (
                                                                    <span className="font-bold text-red-600">
                                                                        {' ('}
                                                                        {/* {!isValid && `min duration: ${minDuration} ${minDurUnit}`} */}
                                                                        {/* {!isValid && incremental && ', '} */}
                                                                        {incremental && `Incremental: ${incremental}`}
                                                                        {')'}
                                                                    </span>
                                                                )}
                                                                <br />
                                                            </>
                                                        )}

                                                        {/* {val?.date && val?.start_time && renderLine( */}
                                                            {/* 'Scheduled Start Time',
                                                            `${moment(val.start_time, "HH:mm:ss").format("h:mm A")}` */}
                                                            {renderScheduledStartTime(val?.date, val?.start_time, val?.end_time)}
                                                        {/* )} */}

                                                        {renderLine('Scheduled Duration', `${val?.estimated_duration} ${val?.estimated_duration_unit}`)}

                                                        {/* {renderActualStartTime(
                                                            val?.date,
                                                            val?.appointment_assign?.checkin_date,
                                                            val?.appointment_assign?.checkin_time
                                                        )} */}
                                                        {renderActualStartTime(
                                                            val?.appointment_assign?.checkin_date,
                                                            val?.appointment_assign?.checkin_time,
                                                            val?.appointment_assign?.checkout_date,
                                                            val?.appointment_assign?.checkout_time
                                                        )}

                                                        {fullDuration && renderLine('Actual Duration', `${fullDuration}`)}
                                                        {fullDuration && renderLine('Total Billable Duration', `${val?.invoice?.extra_duration} minute`)}

                                                        {show(val?.invoice?.rate) &&
                                                            renderLine(
                                                                'Rate',
                                                                `$${val.invoice.rate}/${val.invoice.rate_unit || ''}`
                                                            )
                                                        }

                                                        {val?.invoice?.rush_fee > 0 && (
                                                            <>
                                                                <span>
                                                                    Rush fee: ${val.invoice.rush_fee}
                                                                    <span className="font-bold text-red-600">
                                                                        {' (Scheduled within 24 hours)'}
                                                                    </span>
                                                                </span><br />
                                                            </>
                                                        )}

                                                        {renderLine('Facility Name', val?.appointment_details?.facility?.facility_name)}

                                                        {Number(val?.appointment_details?.requester_details_show_invoice) === 1 && (
                                                        <>
                                                        {renderLine('Requestor Name', val?.appointment_details?.requester_name)}
                                                        {renderLine('Requestor Email', val?.appointment_details?.requester_email)}
                                                        {renderLine('Requestor Phone', val?.appointment_details?.requester_phone)}
                                                        </>
                                                        )}
                                                        {renderLine(
                                                            'Vendor Id',
                                                            val?.interpreter && `${val.interpreter.id}`
                                                        )}
                                                        {Number(val?.appointment_details?.interpreter_name_show_invoice) === 1 &&
                                                        renderLine(
                                                            'Vendor Name',
                                                            val?.interpreter && `${val.interpreter.first_name} ${val.interpreter.last_name}`
                                                        )
                                                        }
                                                        {renderLine('Comments', val?.appointment_assign?.comments)}
                                                        
                                                        {dynamicFieldsList.length > 0 && (
                                                            <>
                                                                <strong>Extra Fields</strong>
                                                                <br />
                                                            </>
                                                        )}

                                                        {dynamicFieldsList.map((f, i) => (
                                                            <>
                                                            <React.Fragment key={i}>
                                                                {renderLine(f?.name, f?.value)}
                                                            </React.Fragment>
                                                            </>
                                                        ))}

                                                        {val?.invoice && (
                                                            <>
                                                                {hasCustomPricing ? (
                                                                    <>
                                                                        <strong>Cost Breakdown:</strong>
                                                                        <br />

                                                                        <span>
                                                                            {`Rate ($${val?.invoice?.rate}/${val.invoice.rate_unit || ''})`} × {val?.invoice?.extra_duration || 0} minutes
                                                                        </span>
                                                                        <br />

                                                                        {val?.appointment_custom_pricing?.mileage_total > 0 && (
                                                                            <>
                                                                                <span>+ Mileage Total: ${val?.appointment_custom_pricing?.mileage_total}</span>
                                                                                <br />
                                                                            </>
                                                                        )}

                                                                        {val?.appointment_custom_pricing?.travel_total > 0 && (
                                                                            <>
                                                                                <span>+ Travel Total: ${val?.appointment_custom_pricing?.travel_total}</span>
                                                                                <br />
                                                                            </>
                                                                        )}

                                                                        {/* {(val?.appointment_custom_pricing?.sub_total > 0 &&
                                                                            val?.appointment_custom_pricing?.discount > 0) && (
                                                                            <>
                                                                                <span>= Sub Total: ${val?.appointment_custom_pricing?.sub_total}</span>
                                                                                <br />
                                                                            </>
                                                                        )} */}

                                                                        {val?.appointment_custom_pricing?.discount > 0 && (
                                                                            <>
                                                                                <span>+ Discount: {val?.appointment_custom_pricing?.discount}%</span>
                                                                                <br />
                                                                            </>
                                                                        )}

                                                                        {val?.invoice?.rush_fee > 0 && (
                                                                            <>
                                                                                <span>+ Rush Fee: ${val?.invoice?.rush_fee}</span>
                                                                                <br />
                                                                            </>
                                                                        )}

                                                                        <span className="font-bold">
                                                                            = Total Cost: ${val?.invoice?.total_amount?.toFixed(2)}
                                                                        </span>
                                                                    </>
                                                                ) : (
                                                                    <span className="font-bold">
                                                                        Total Cost: ${val?.invoice?.total_amount?.toFixed(2)}
                                                                    </span>
                                                                )}
                                                            </>
                                                        )}

                                                        {/* Old Invoice ////////////////// */}

                                                        {/* {renderLine('Status', val?.status)}
                                                        {renderLine('Appointment type', val?.type)}
                                                        {renderLine(
                                                            'Appointment date',
                                                            val?.date && moment(val.date).format("DD/MM/YYYY")
                                                        )}
                                                        {renderLine('Scheduled Duration', `${val?.estimated_duration} ${val?.estimated_duration_unit}`)}

                                                        {val?.date && val?.start_time && renderLine(
                                                            'Scheduled Start Date Time',
                                                            `${moment(val.date).format("DD/MM/YYYY")} ${moment(val.start_time, "HH:mm:ss").format("h:mm A")}`
                                                        )}

                                                        {val?.date && val?.end_time && renderLine(
                                                            'Scheduled End Date Time',
                                                            `${moment(val.date).format("DD/MM/YYYY")} ${moment(val.end_time, "HH:mm:ss").format("h:mm A")}`
                                                        )}

                                                        {val?.appointment_assign?.checkin_time && renderLine(
                                                            'Actual Start Time',
                                                            `${moment(val.appointment_assign.checkin_date).format("DD/MM/YYYY")} ${moment(val.appointment_assign.checkin_time, "HH:mm:ss").format("h:mm A")}`
                                                        )}

                                                        {val?.appointment_assign?.checkout_time && renderLine(
                                                            'Actual End Time',
                                                            `${moment(val.appointment_assign.checkout_date).format("DD/MM/YYYY")} ${moment(val.appointment_assign.checkout_time, "HH:mm:ss").format("h:mm A")}`
                                                        )}

                                                        {exceededTime && renderLine('Exceeded Time', exceededTime)}
                                                        
                                                        {fullDuration && renderLine('Full Duration', `${val?.invoice?.extra_duration} minute`)}
                                                        {val?.invoice?.min_duration && renderLine('Minimum Duration', `${val?.invoice?.min_duration} ${val?.invoice?.duration_unit}`)}

                                                        {show(val?.invoice?.total_hours) && (
                                                            <>
                                                                <span>
                                                                    Appointment duration:&nbsp;
                                                                    {moment.utc(
                                                                        moment.duration(val.invoice.total_hours, "HH:mm").asMilliseconds()
                                                                    ).format("HH:mm")}
                                                                </span>

                                                                {(isValid === false || incremental) && (
                                                                    <span className="font-bold text-red-600">
                                                                        {' ('}
                                                                        {!isValid && `min duration: ${minDuration} ${minDurUnit}`}
                                                                        {!isValid && incremental && ', '}
                                                                        {incremental && `Incremental: ${incremental}`}
                                                                        {')'}
                                                                    </span>
                                                                )}
                                                                <br />
                                                            </>
                                                        )}

                                                        {show(val?.invoice?.rate) &&
                                                            renderLine(
                                                                'Rate',
                                                                `$${val.invoice.rate}/${val.invoice.rate_unit || ''}`
                                                            )
                                                        }

                                                        {val?.invoice?.rush_fee > 0 && (
                                                            <>
                                                                <span>
                                                                    Rush fee: ${val.invoice.rush_fee}
                                                                    <span className="font-bold text-red-600">
                                                                        {' (Scheduled within 24 hours)'}
                                                                    </span>
                                                                </span><br />
                                                            </>
                                                        )}

                                                        {renderLine('Facility', val?.appointment_details?.facility?.facility_name)}
                                                        {renderLine('Facility Address', val?.appointment_details?.address)}
                                                        {renderLine('Department', val?.appointment_details?.department?.department_name)}
                                                        {renderLine('Department text', val?.appointment_details?.department_text)}
                                                        {renderLine('Requestor Name', val?.appointment_details?.requester_name)}
                                                        {renderLine('Requestor Email', val?.appointment_details?.requester_email)}
                                                        {renderLine('Requestor Phone', val?.appointment_details?.requester_phone)}
                                                        {renderLine(
                                                            'Interpreter Name',
                                                            val?.interpreter && `${val.interpreter.first_name} ${val.interpreter.last_name}`
                                                        )}
                                                        {renderLine('Comments', val?.appointment_assign?.comments)}
                                                        {renderLine('Notes', val?.appointment_assign?.notes)}

                                                        {val?.invoice && (
                                                            <>
                                                                <br />
                                                                <span className="font-bold">
                                                                    Cost Breakdown:
                                                                </span>
                                                                <br />

                                                                <span>
                                                                    {`Rate ($${val?.invoice?.rate}/${val.invoice.rate_unit || ''})`} × {val?.invoice?.extra_duration || 0}
                                                                    {' minutes'}
                                                                </span>
                                                                <br />
                                                                {val?.appointment_custom_pricing?.mileage_total > 0 && (
                                                                    <>
                                                                        <span>+ Mileage Total: ${val?.appointment_custom_pricing?.mileage_total}</span>
                                                                        <br />
                                                                    </>
                                                                )}
                                                                {val?.appointment_custom_pricing?.travel_total > 0 && (
                                                                    <>
                                                                        <span>+ Travel Total: ${val?.appointment_custom_pricing?.travel_total}</span>
                                                                        <br />
                                                                    </>
                                                                )}
                                                                {(val?.appointment_custom_pricing?.sub_total > 0 && val?.appointment_custom_pricing?.discount > 0) && (
                                                                    <>
                                                                        <span>= Sub Total: ${val?.appointment_custom_pricing?.sub_total}</span>
                                                                        <br />
                                                                    </>
                                                                )}
                                                                {val?.appointment_custom_pricing?.discount > 0 && (
                                                                    <>
                                                                        <span>+ Discount: {val?.appointment_custom_pricing?.discount}%</span>
                                                                        <br />
                                                                    </>
                                                                )}

                                                                {val?.invoice?.rush_fee > 0 && (
                                                                    <>
                                                                        <span>+ Rush Fee: ${val?.invoice?.rush_fee}</span>
                                                                        <br />
                                                                    </>
                                                                )}

                                                                <span className="font-bold">
                                                                    = Total Cost: ${val?.invoice?.total_amount?.toFixed(2)}
                                                                </span>
                                                                <br />
                                                            </>
                                                        )} */}
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                ${val?.invoice?.total_amount
                                                    ? val.invoice.total_amount.toFixed(2)
                                                    : '0.00'}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </React.Fragment>
                        ))}
                            </tbody>
                        </table>
                    </div>

                    <table className="info-container last_info">
                        <tbody>
                            <tr>
                                <th className='text-end last_due'>Total Due</th>
                                <th className='text-end last_due'>${totalBill}</th>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>

            {loader && <FullPageLoader />}
        </>
    );
};

export default PdfForm;
